import { useLevelStructures } from '../api/getLevelStructures';
import { useRoles } from '../api/getRoles';

export const useLotMatrix = (resource, id, lotId) => {
  const { data: roles, isFetchedAfterMount: areRolesFetched } = useRoles(resource, id, lotId);
  const { data: structures, isFetchedAfterMount: areStructuresFetched } = useLevelStructures(
    resource,
    id
  );

  return { roles, structures, isLoaded: areRolesFetched && areStructuresFetched };
};
